import I18n from "i18n-js";
import { fetch } from "../../../appContainer";
import {
  GET_PRESSURE_GAUGES_LIST_IN_PROGRESS,
  GET_PRESSURE_GAUGES_LIST_SUCCESS,
  GET_PRESSURE_GAUGES_LIST_FAIL,
  GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS,
  GET_PRESSURE_GAUGE_INFOS_SUCCESS,
  GET_PRESSURE_GAUGE_INFOS_FAIL,
  POST_PRESSURE_GAUGE_IN_PROGRESS,
  POST_PRESSURE_GAUGE_SUCCESS,
  POST_PRESSURE_GAUGE_FAIL,
  PUT_PRESSURE_GAUGE_IN_PROGRESS,
  PUT_PRESSURE_GAUGE_SUCCESS,
  PUT_PRESSURE_GAUGE_FAIL,
  DELETE_PRESSURE_GAUGE_IN_PROGRESS,
  DELETE_PRESSURE_GAUGE_SUCCESS,
  DELETE_PRESSURE_GAUGE_FAIL,
} from "../constants";
import { SUBMIT_SUCCESS, SUBMIT_FAIL } from "../../common/constants";

/**
 * Create pressure gauge
 *
 * @param {Object} pressureGauge
 */
export function createPressureGauge(pressureGauge) {
  return (dispatch) => {
    dispatch({ type: POST_PRESSURE_GAUGE_IN_PROGRESS });

    fetch("api").createPressureGauge(
      pressureGauge,
      () => {
        const message = I18n.t("alerts.add:pressure_gauge.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: POST_PRESSURE_GAUGE_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.add:pressure_gauge.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: POST_PRESSURE_GAUGE_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Update pressure gauge
 *
 * @param {String} uuid
 * @param {Object} pressureGauge
 */
export function updatePressureGauge(uuid, pressureGauge) {
  return (dispatch) => {
    dispatch({ type: PUT_PRESSURE_GAUGE_IN_PROGRESS });

    fetch("api").updatePressureGauge(
      uuid,
      pressureGauge,
      () => {
        const message = I18n.t("alerts.update:pressure_gauge.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: PUT_PRESSURE_GAUGE_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.update:pressure_gauge.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: PUT_PRESSURE_GAUGE_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Get pressure gauges list
 */
export function getPressureGaugesList() {
  return (dispatch) => {
    dispatch({ type: GET_PRESSURE_GAUGES_LIST_IN_PROGRESS });

    fetch("api").getPressureGaugesList(
      (list) => {
        dispatch({ type: GET_PRESSURE_GAUGES_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_PRESSURE_GAUGES_LIST_FAIL }),
    );
  };
}

/**
 * Delete pressure gauge
 *
 * @param {String} uuid
 */
export function deletePressureGauge(uuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_PRESSURE_GAUGE_IN_PROGRESS });

    fetch("api").deletePressureGauge(
      uuid,
      () => {
        const message = I18n.t("alerts.delete:pressure_gauge.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch(getPressureGaugesList());
        dispatch({ type: DELETE_PRESSURE_GAUGE_SUCCESS });
      },
      () => {
        const message = I18n.t("alerts.delete:pressure_gauge.fail");

        dispatch({ type: DELETE_PRESSURE_GAUGE_FAIL });
        dispatch({ type: SUBMIT_FAIL, payload: { message } });
      },
    );
  };
}

/**
 * Get pressure gauge infos
 */
export function getPressureGaugeInfos(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_PRESSURE_GAUGE_INFOS_IN_PROGRESS });

    fetch("api").getPressureGaugeInfos(
      uuid,
      (infos) => {
        dispatch({ type: GET_PRESSURE_GAUGE_INFOS_SUCCESS, payload: { infos } });
      },
      () => dispatch({ type: GET_PRESSURE_GAUGE_INFOS_FAIL }),
    );
  };
}
